import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useCallback, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import KatexRenderer from './KatexRenderer';
import { Button, Checkbox, Textarea, TextInput } from '@mantine/core';
import { LexicalEditor } from 'lexical';

type Props = {
  editor: LexicalEditor;
  initialEquation?: string;
  onConfirm: (equation: string, inline: boolean) => void;
};

export function KatexEquationAlterer({
  editor,
  onConfirm,
  initialEquation = '',
}: Props): JSX.Element {
  const [equation, setEquation] = useState<string>(initialEquation);
  const [inline, setInline] = useState<boolean>(true);

  const onClick = useCallback(() => {
    onConfirm(equation, inline);
  }, [onConfirm, equation, inline]);

  const onCheckboxChange = useCallback(() => {
    setInline(!inline);
  }, [setInline, inline]);

  return (
    <>
      <Checkbox
        defaultChecked
        label="Render equation inline"
        checked={inline}
        onChange={onCheckboxChange}
        mb="md"
      />
      {inline ? (
        <TextInput
          onChange={(event) => {
            setEquation(event.target.value);
          }}
          value={equation}
        />
      ) : (
        <Textarea
          autosize
          onChange={(event) => {
            setEquation(event.target.value);
          }}
          value={equation}
        />
      )}
      <ErrorBoundary onError={(e) => editor._onError(e)} fallback={null}>
        <KatexRenderer equation={equation} inline={false} onDoubleClick={() => null} />
      </ErrorBoundary>
      <Button onClick={onClick}>Confirm</Button>
    </>
  );
}
